import { Box, Button, Stack, Tab, Tabs, Typography } from '@mui/material'
import { AgGridReact } from '@ag-grid-community/react'
import { useLocation, useNavigate } from "react-router-dom";
import { PIDashboardColumns } from "./PIDashboardColumns";
import KeyboardReturnOutlinedIcon from '@mui/icons-material/KeyboardReturnOutlined';
import { SyntheticEvent, useState } from "react";
import RemoveSubApplicantModal from "./components/RemoveSubApplicantModal";
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import { useGetDUCInfoQuery, useGetOwnershipTransferStatusQuery, useGetSubApplicantsQuery } from "../../api/ducApiSlice";
import { useUserInfoQuery } from "../../api/userApiSlice";

const PIDashboard = () => {
    const { data: userData } = useUserInfoQuery({});
    const { data } = useGetSubApplicantsQuery({ username: userData?.username });
    const { data: DUCData } = useGetDUCInfoQuery({ email: userData['email'] })
    const ducData = DUCData?.GENERAL?.[DUCData?.GENERAL?.length - 1]
    const { data: transferStatus } = useGetOwnershipTransferStatusQuery(
        { ducDetailsId: ducData?.ducDetailsId },
        { skip: !ducData?.ducDetailsId }
    )
    // Once the PI has initiated an ownership transfer, sub-applicant membership should be
    // frozen until it resolves - mirrors the hasActiveTransfer gate in GeneralBlockButtons.
    const hasActiveTransfer: boolean = !!transferStatus?.transferId
    const location = useLocation()
    const navigate = useNavigate()
    const [open,setOpen] = useState(false)
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [id, setId] = useState("")
    const [ tab, setTab ] = useState(location.state?.type || "GENERAL");


    const handleClickDelete = (event: any) => {
        // "TrainingComplete" is an equally revocable status alongside "Approved" (LC-6452) - keep
        // this in sync with GetRevoked's enablement check in PiTableRenderers, which already
        // allows both; otherwise the icon renders enabled but the click silently no-ops.
        const isRevocableStatus = event.data.ducStatus === "Approved" || event.data.ducStatus === "TrainingComplete";
        // Mirror GetRevoked's isCancelled gate in PiTableRenderers - a stale sub-applicant left
        // over from a cancelled ownership transfer belongs to the original PI's still-valid DUC,
        // so it must not be revocable from here even though the icon click still reaches us.
        if(event.colDef.field === "remove" && isRevocableStatus && event.data.isRemoved !== true && event.data.isCancelled !== true && !hasActiveTransfer){
            setOpen(true)
            setName(event.data.fullName)
            setEmail(event.data.email)
            setId(event.data.id)
        }
    }

    const handelCLickAdd = () => {
        localStorage.setItem('AddSub', "true")
        localStorage.setItem('edit', "true")
        localStorage.setItem('isGroup', "true")
        localStorage.setItem("formType", tab)
        navigate("/duc/request")
    }

    const changeTab = (event: SyntheticEvent, newValue: string) => {
        setTab(newValue);
    }

    const checkDisabled = () => {
        if(data?.[tab]?.length === 0){
            return true
        }
        const ducDataTab = DUCData?.[tab]
        const isDuc1NotApproved = ducDataTab?.[0]?.status !== "Approved";
        const does2DucExist = (ducDataTab?.length === 2);
        const isDuc2InProgressOrSubmitted = ducDataTab?.[1]?.status === "Submitted" || ducDataTab?.[1]?.status === "InProgress"
        return isDuc1NotApproved || (does2DucExist && isDuc2InProgressOrSubmitted) || hasActiveTransfer;
    }

    return (
        <Stack height="100%" gap={4}>
            <Typography fontSize="40px" fontWeight={600} textAlign="center">Investigator Dashboard </Typography>
            <Stack flexDirection="row" justifyContent="space-between">
                <Button
                    startIcon={<KeyboardReturnOutlinedIcon/>}
                    variant="tertiary"
                    onClick={() => navigate("/duc")}
                >Back to DUC dashboard</Button>

                <Button
                    variant="primary"
                    disabled={checkDisabled()}
                    startIcon={<AddBoxOutlinedIcon/>}
                    onClick={handelCLickAdd}>
                    Add new Sub-applicant
                </Button>

            </Stack>
            <Box width="100%" height="100%" className="ag-theme-material ag-theme-common ag-theme-acmecorp">
                <Typography fontSize="18px" fontWeight="600">Sub-applicants in your group</Typography>
                <Tabs value={tab} onChange={changeTab}>
                    <Tab value="GENERAL" label={`General (${data?.GENERAL?.length})`} />
                    <Tab value="AIAN" label={`AIAN (${data?.AIAN?.length})`} />
                </Tabs>
                <AgGridReact rowData={data?.[tab]} columnDefs={PIDashboardColumns}
                    context={{ hasActiveTransfer }}
                    rowSelection={{ mode: "multiRow", headerCheckbox: true, checkboxes: true }}
                    onCellClicked= {(event: any) => handleClickDelete(event)}/>
            </Box>
            <RemoveSubApplicantModal open={open} setOpen={setOpen} name={name} email={email} id={id}/>
        </Stack >
    )
}

export default PIDashboard
